import React, { useRef, useEffect } from "react";

import I18nHOC from "UIComponents/I18nHOC";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

import { connect } from "react-redux";
import { compose } from "lib/apolloClient";

const printableCharactersRegex = /^[ -~]$/;

const Editor = ({
  value,
  onChange,
  setToastMsg,
  shiftOn,
  mathLiveFieldContainerRef,
  timer,
  MATHFIELD_ID,
  SHADOW_ROOT_QUERY_SELECTOR,
  MAX_EQUATION_WIDTH,
  automate = false,
  allowCopyPasteInEquationEditor = true,
}) => {
  const timerRef = useRef();

  // commenting for now.....Can't remember what was the usecase for this.
  // // add copy eventListener on load
  // React.useEffect(() => {
  //   const copyText = e => {
  //     setCopiedLatex(null);
  //     const clipboardData = e.clipboardData || window.Clipboard;
  //     const copiedData = clipboardData.getData("Text");
  //     clipboardData.setData("text/plain", copiedData);
  //     e.preventDefault();
  //   };

  //   document.addEventListener("copy", copyText);

  //   return () => {
  //     document.removeEventListener("copy", copyText);
  //   };
  // }, []);

  useEffect(() => {
    const mf = mathLiveFieldContainerRef.current;
    const targetNode = mf?.shadowRoot?.querySelectorAll(
      SHADOW_ROOT_QUERY_SELECTOR
    )[0];

    if (targetNode) {
      mf.mathModeSpace = "\\;";
      mf.smartSuperscript = true;
      mf.smartFence = true;

      const handleKeyDown = ev => {
        blockMultiline(ev);

        // * Prevent Copy, Cut and Paste if allowCopyPasteInEquationEditor is false
        if (!allowCopyPasteInEquationEditor) {
          const isControlKey = ev.metaKey || ev.ctrlKey;
          const restrictedKeys = ["c", "x", "v"];
          if (isControlKey && restrictedKeys.includes(ev.key)) {
            ev.preventDefault();
            return;
          }
        }

        if ((ev.metaKey || ev.ctrlKey) && ev.key == "v") {
          ev.preventDefault();

          if (mf && mathLiveFieldContainerRef.current) {
            const { width } = targetNode.getBoundingClientRect();
            if (width < MAX_EQUATION_WIDTH) {
              navigator.clipboard.readText().then(clipText => {
                if (clipText !== "\\begin{equation*}  \\end{equation*}") {
                  mf.executeCommand([
                    "insert",
                    clipText.replaceAll(" ", "\\;"),
                    {
                      insertionMode: "replaceSelection",
                      selectionMode: "placeholder",
                    },
                  ]);
                }
              });
            } else {
              clearTimeout(timer);
              timer = setTimeout(
                () => setToastMsg("toastMsgs:equation_width_limit_reached"),
                500
              );
            }
          }
        }
        if (!ev.metaKey && !ev.ctrlKey) {
          // limit width of equation
          const { width } = targetNode.getBoundingClientRect();
          if (
            width > MAX_EQUATION_WIDTH &&
            printableCharactersRegex.test(ev.key)
          ) {
            ev.preventDefault();
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(
              () => setToastMsg("toastMsgs:equation_width_limit_reached"),
              500
            );
            return false;
          } else {
            if (ev.key === "\\") {
              ev.preventDefault();
            }
          }
        }
      };

      const isEnterEvent = e => e && (e.key === "Enter" || e.code === "Enter");

      const blockMultiline = e => {
        if (isEnterEvent(e) && (e.metaKey || e.ctrlKey)) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      };

      mf?.addEventListener("keydown", handleKeyDown, true);

      return () => {
        mf?.removeEventListener("keydown", handleKeyDown, true);
      };
    }
  }, []);

  React.useEffect(() => {
    const mf = document.getElementById(MATHFIELD_ID);
    if (!mf) return;

    const shadow = mf.shadowRoot;
    if (shadow) {
      const style = document.createElement("style");
      style.textContent = `
        .ML__mathit {
          transform: translateY(-3px);
        }
      `;
      shadow.appendChild(style);
    }
  }, []);

  return (
    // ASK: what is this?
    <math-field
      ref={ref => {
        if (ref && !mathLiveFieldContainerRef.current) {
          !automate && ref.focus();
          const targetNode = ref.shadowRoot.querySelectorAll(
            SHADOW_ROOT_QUERY_SELECTOR
          )[0];
          targetNode.style.width = "auto";
          ref.menuItems = [];
          mathLiveFieldContainerRef.current = ref;
        }
      }}
      value={value}
      onInput={onChange}
      id={MATHFIELD_ID}
      default-mode="math" // inline-math, math
      letter-shape-style="auto"
      popover-policy="off"
      style={{
        border: "1px solid #dbdbdb",
        padding: "8px 16px",
        borderRadius: 4,
        fontSize: 16,
        width: "100%",
        height: "100%",
        maxHeight: 104,
        overflowY: "auto",
        outline: "none",
        "--caret": "#333333",
        "--highlight": "#dedede",
        "--contains-highlight": "#dedede",
      }}
    >
      {value}
    </math-field>
  );
};

const mapActionCreators = {
  setToastMsg,
};

export default compose(
  I18nHOC({ resource: "toastMsgs" }),
  connect(s => s, mapActionCreators, null, { withRef: true })
)(Editor);
